package com.dignicate.web.theme

import kotlinx.browser.window

fun detectSystemDark(): Boolean =
    window.matchMedia("(prefers-color-scheme: dark)").matches

fun detectSystemLang(): String {
    val raw = window.navigator.language.lowercase()
    console.log("detectSystemLang: navigator.language = $raw")
    val result = if (raw.startsWith("ja")) "ja" else "en"
    console.log("detectSystemLang: returning $result")
    return result
}
